import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

interface CopyrightNoticeProps {
  variant?: "caption" | "body2";
  align?: "center" | "left" | "right";
}

export function CopyrightNotice({
  variant = "caption",
  align = "center",
}: CopyrightNoticeProps) {
  const { t } = useTranslation("common");
  return (
    <Typography
      variant={variant}
      color="text.disabled"
      align={align}
      display="block"
    >
      {t("auth.copyrightLine", { year: new Date().getFullYear() })}
    </Typography>
  );
}
